import styled from 'styled-components';
import {Select as MantineSelect} from '@mantine/core';

interface ContainerProps {
  gridColumn?: number;
  focus: boolean;
  border?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  ${(props) => props.border && 'border: 1px solid rgba(128, 128, 128, 0.6);'};

  .input {
    height: 100%;
    outline: none;
    border-radius: 3px;

    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
  }

  .mantine-Input-input::placeholder {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 600;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
`;

export const StyledSelect = styled(MantineSelect).attrs((props) => ({
  styles: {
    root: {width: '100%'},
    wrapper: {minHeight: 30},
    rightSection: {display: 'none'},
    selected: {
      backgroundColor: props.theme.colors.primaryLight,
      color: props.theme.colors.primary,
    },
    values: {width: '100%'},
    input: {
      padding: 0,
      outline: 'none',
      border: 'none',
      color: 'black',
      fontWeight: 600,
    },
  },
  classNames: {input: 'input'},
}))``;
